<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pFrontFlap"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a>
<div class="copyright">
<p class="center ">Copyright © 2007 by Thomas H. Cook</p>
<div class="timebreak "> </div>
<p class="center ">All rights reserved. No part of this publication may be reproduced or<br/>
transmitted in any form or by any means, electronic or mechanical,<br/>
including photocopy, recording, or any information storage and retrieval<br/>
system, without permission in writing from the publisher.</p>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center "><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<div class="timebreak "> </div>
<p class="center ">Library of Congress Cataloging-in-Publication Data<br/>
Cook, Thomas H.<br/>
The cloud of unknowing/Thomas H. Cook.—1st ed.<br/>
p. cm.<br/>
“An Otto Penzler book.”<br/>
1. Brothers and sisters—Fiction. 2. Schizophrenia—Fiction. 3. Family—Fiction. 4. Psychological fiction. I.Title.<br/>
PS3553.O55465C57 2007<br/>
813'.54—dc22 2006013951<br/>
<span class="smallcaps">ISBN</span>-13: 978-0-15-101260-2 <span class="smallcaps">ISBN</span>-10: 0-15-101260-1</p>
<div class="timebreak "> </div>
<p class="center ">e<span class="smallcaps">ISBN</span> 978-0-547-53815-0<br/>
v2.1017</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?6f0fdac7